import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse, ListResponse, Transaction } from 'types';

const useLDWithdrawProposals = (): UseQueryResult<
  ListResponse<Transaction>,
  ErrorResponse
> => {
  return useQuery([url.withdrawRequests]);
};
export default useLDWithdrawProposals;
